import { useEffect, useState } from "react";
import { Link } from "react-router";
import type { AssistantHit } from "@handvero/shared";
import { api } from "../api";
import { hitLink, KIND_LABEL } from "./Mascot";
import { Icon } from "./ui";

/*
 * Suche über alles: Das Suchfeld der Projektliste zeigt zusätzlich Treffer in Ordnern, Dateien, Notizen, Terminen,
 * Gerätekarten und (mit Rechnungsmodul) Kunden. Läuft auf dem HandVero-Server, nur Daten, die die Person sehen darf.
 */

export function useGlobalHits(query: string): AssistantHit[] {
  const [hits, setHits] = useState<AssistantHit[]>([]);
  useEffect(() => {
    const q = query.trim();
    if (q.length < 2) {
      setHits([]);
      return;
    }
    let alive = true;
    const t = window.setTimeout(() => {
      api.get<{ hits: AssistantHit[] }>(`/api/search?q=${encodeURIComponent(q)}`).then(
        (r) => alive && setHits(r.hits),
        () => alive && setHits([]),
      );
    }, 300);
    return () => {
      alive = false;
      window.clearTimeout(t);
    };
  }, [query]);
  return hits;
}

/** Treffer außer Projekten (die zeigt die Liste selbst). Kunden gibt es nur am PC. */
export function GlobalHits({ base, query }: { base: "/app" | "/desktop"; query: string }) {
  const hits = useGlobalHits(query).filter((h) => h.kind !== "project" && (base === "/desktop" || h.kind !== "customer"));
  if (!hits.length) return null;
  return (
    <div className="ghits">
      <h4>Weitere Treffer</h4>
      <ul className="vero-hits">
        {hits.map((h) => {
          const [label, icon] = KIND_LABEL[h.kind];
          return (
            <li key={`${h.kind}-${h.id}`}>
              <Link to={hitLink(base, h)}>
                <span className="vero-hit-ico">
                  <Icon name={icon} />
                </span>
                <span className="vero-hit-text">
                  <b>{h.title}</b>
                  <small>
                    {label} · {h.sub}
                  </small>
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
